import React from 'react';

const CreateOrderSuccessSkeleton: React.FC = () => (
  <div className="grid grid-cols-1 lg:grid-cols-11 my-6 lg:gap-12 lg:px-8 min-h-[calc(100vh-200px)] animate-pulse">
    {/* Left side: carousel and event details (hidden on in-person flow) */}
    <div className="col-span-4 flex flex-col gap-4 w-full mb-6">
      <div className="w-full overflow-hidden rounded-2xl">
        <div className="w-full aspect-[1920/700] bg-neutral-200 dark:bg-neutral-700 rounded-2xl" />
      </div>
      <div className='glass-surface text-center lg:text-left'>
        <div className="h-8 w-3/4 bg-neutral-200 dark:bg-neutral-700 rounded-md mb-2" />
        <div className="h-6 w-1/2 bg-neutral-200 dark:bg-neutral-700 rounded-md" />
      </div>
    </div>

    {/* Right side: success panel and details */}
    <div className='col-span-7 flex flex-col gap-6'>
      <div className="flex flex-col md:flex-row gap-6 glass-surface p-4">
        <div className="flex items-center justify-center p-4">
          <div className="w-[147px] h-[147px] bg-neutral-200 dark:bg-neutral-700 rounded-full" />
        </div>
        <div className="flex flex-col gap-4 p-2 justify-center text-center md:text-left w-full">
          <div className="h-8 w-64 bg-neutral-200 dark:bg-neutral-700 rounded-md" />
          <div className="h-5 w-80 bg-neutral-200 dark:bg-neutral-700 rounded-md" />
          <div className="h-5 w-72 bg-neutral-200 dark:bg-neutral-700 rounded-md" />
        </div>
      </div>

      <div className='flex flex-col gap-6'>
        <div className="glass-surface p-4">
          {[...Array(3)].map((_, i) => (
            <div key={i} className="my-2">
              <div className="h-5 w-3/4 bg-neutral-200 dark:bg-neutral-700 rounded-md mb-2" />
              <div className="h-4 w-40 bg-neutral-200 dark:bg-neutral-700 rounded-md" />
            </div>
          ))}
        </div>
        <div className="glass-surface p-4">
          <div className="h-5 w-2/3 bg-neutral-200 dark:bg-neutral-700 rounded-md mx-auto" />
        </div>
      </div>

      {/* Backoffice buttons / public tips area */}
      <div className="flex flex-col md:flex-row gap-4">
        <div className="h-10 w-64 bg-neutral-200 dark:bg-neutral-700 rounded-2xl" />
        <div className="h-10 w-52 bg-neutral-200 dark:bg-neutral-700 rounded-2xl" />
      </div>
    </div>
  </div>
);

export default CreateOrderSuccessSkeleton;
